import React, { useState } from 'react';
import { Box, Button,  VStack, Heading, Span } from '@bpba/ui-components';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { Queries } from '../rest/Queries';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Localidad } from '../rest/models/Localidad';
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { getLocalidadesSuc } from '../rest/queries/getLocalidadesSuc';
import { getSucursales } from '../rest/queries/getSucursales';
import { getPartidosSuc } from '../rest/queries/getPartidosSuc';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Partido } from '../rest/models/Partido';
import { Sucursal } from '../rest/models/Sucursal';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';
import { TarjetaPactarSP } from '../rest/models/TarjetaPactarSP';
import { TarjetaPactarSPApiRQ } from '../rest/models/TarjetaPactarSPApiRQ';
import { postTarjetaPactarSP } from '../rest/mutations/postTarjetaPactarSP';


const validateRealCuit = (cuit: string) => {
    let rv = false;

    let resultado = 0;
    const codes = "6789456789";
    let verificador = parseInt(cuit[cuit.length - 1]);
    let x = 0;

    while (x < 10) {
        let digitoValidador = parseInt(codes.substring(x, x + 1));
        if (isNaN(digitoValidador)) digitoValidador = 0;
        let digito = parseInt(cuit.substring(x, x + 1));
        if (isNaN(digito)) digito = 0;
        let digitoValidacion = digitoValidador * digito;
        resultado += digitoValidacion;
        x++;
    }
    resultado = resultado % 11;
    rv = resultado === verificador;

    return rv ? rv : "Verifique el Cuit ingresado";
};



const ComponenteTarjetaPactar: React.FC = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');

    const { register, handleSubmit,resetField, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            sucursal: ""
        }
    });

    const [idProvinciaSuc, setIdProvinciaSuc] = useState<string>();
    const [idLocalidadSuc, setIdLocalidadSuc] = useState<string>();
    const [idPartidoSuc, setIdPartidoSuc] = useState<string>();
    const REQUIRED_FIELD = "Campo requerido.";
    //eslint-disable-next-line
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const [errorServicio] = useState<boolean>(false);
    const [mensajeError] = useState<string>("");
    const [mensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const [postTarjetaPactarAPI,{loading:loadingMutation}] = useMutation<Mutations>(postTarjetaPactarSP);
    const { data: { localidadesSuc } = {}} = useQuery<Queries>(getLocalidadesSuc, { variables: { idPartido: idPartidoSuc }, skip: !idPartidoSuc });
    const { data: { partidosSuc } = {}} = useQuery<Queries>(getPartidosSuc, { variables: { idProvincia: idProvinciaSuc }, skip: !idProvinciaSuc });
    const { data: { sucursales } = {}} = useQuery<Queries>(getSucursales, { variables: { idLocalidadSuc: idLocalidadSuc, filterBranch: 1 }, skip: !idLocalidadSuc });
    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");

    const onSubmit: SubmitHandler<TarjetaPactarSP> = async (data: TarjetaPactarSP) => {
    
        const token = executeRecaptcha && (await executeRecaptcha('TarjetaPactar'));
        let datos: TarjetaPactarSPApiRQ = {
          "googleToken": token,
          "cuit": data.cuit,
          "razonSocial": data.nombre,
          "email": data.email,
          "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
          "localidad": data.provincia.split('-')[1] + "," + data.localidad + "," + data.calle + " " + data.numeroCalle + "," + data.piso,
          "sucursal": Number.parseInt((data.sucursal === "0" ? "1000" : data.sucursal)),
          "origenSolicitud": origenSolicitud=== null? "":origenSolicitud
        };

        await postTarjetaPactarAPI({ variables: { input: datos } }).then((response: any) => {
          
          
          if (response !== null || response !== undefined) {
            
            setServicioOk(true);
            if (response.data.TarjetaPactarSPApiRQ.resultado === "ok") {
                
                setMensajeRtaServicio("Solicitud creada con éxito.En los próximos días nos contactaremos con vos.");

            } else if (response.data.TarjetaPactarSPApiRQ.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())) {
                
                setMensajeRtaServicio(response.data.TarjetaPactarSPApiRQ.error);

            } else {
                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
            }
          } else {
            
            setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
          }
        }).catch(() => {
          
            setServicioOk(true);
            setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
        }); 
      }


    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);

    }
   

    if (loadingMutation) return <SpinnerCajas />;
    const handleReset = () => {
        reset({});
        window.location.reload();
      };
    if (servicioOk) return (

        <Result handleReset={handleReset}>
            <ResultExito message={mensajeRtaServicio}></ResultExito>
        </Result>
        
    );
   if (mensajeErrorPostProspecto!=="" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );
  
 
    function BuscPartidosSuc(formId: string) {
        setIdProvinciaSuc(formId.split('-')[0]);
        setIdPartidoSuc('');
        setIdLocalidadSuc('');
        resetField('localidadSuc');
        resetField('sucursal');
    }
    function BuscLocSuc(formId: string) {
        setIdPartidoSuc(formId.split('-')[0]);
        if (formId === '') {
            setIdLocalidadSuc('');

        }
        resetField('localidadSuc');
        resetField('sucursal');
    }

    function BuscSuc(formId: string) {
        setIdLocalidadSuc(formId.split('-')[0]);
        resetField('sucursal');
    }
    
    
    return (

        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>
                   
                            <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                                Datos Generales
                            </Heading>
                            {errorServicio?
                                <VStack mt={"20px"}>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {mensajeError}
                                    </Span>
                                </VStack>:<></>
                            }  
                       
                            <VStack mt={"20px"}>

                                <input {...register(`nombre`, { required: REQUIRED_FIELD, maxLength: 100 })} name='nombre' type={"text"} defaultValue={""} placeholder='Nombre y apellido / Nombre de la empresa' maxLength={100}/>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombre?"* "+errors.nombre.message:""}</Span>
                            </VStack>
                            <VStack mt={"20px"}>
                                <input type={"text"} tabIndex={0}
                                    {...register("cuit", {
                                        required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                        maxLength: 11, validate: (value) => validateRealCuit(value.toString())
                                    })}
                                    name='cuit' id='cuit' placeholder='CUIT/CUIL ej: 30123456789' maxLength={11} minLength={11} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {errors.cuit?"* "+errors.cuit.message:""}
                                </Span>
                            </VStack>
                            <VStack mt={"20px"}>
                                <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email?"* "+errors.email.message:""}</Span>
                            </VStack>
                          
                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{lineHeight:"18px"}}>
                                    Teléfono de contacto
                                </Span>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea?"* "+errors.telefonoArea.message:""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono?"* "+errors.telefono.message:""}</Span>
                                    </VStack>
                                </VStack>
                            </VStack>
                            <VStack mt={"20px"}>
                                <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{lineHeight:"18px"}} tabIndex={0}>Domicilio Real / Legal </Span>

                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                            style={{ width: "100%" }}
                                            {...register("provincia", { required: REQUIRED_FIELD })}
                                            onChange={(e: any) => BuscLoc(e.target.value)} name="provincia" placeholder='Provincia' >
                                            <option value="">Provincia</option>
                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provincia?"* "+errors.provincia.message:""}</Span>
                                    </VStack>
                                    <VStack >
                                        <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidad", { required: REQUIRED_FIELD })} name="localidad" placeholder='Localidad' >
                                            <option value="" selected >Localidad </option>
                                            {localidades &&
                                                localidades.map((item: Localidad) =>
                                                    <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                )}
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidad?"* "+errors.localidad.message:""}</Span>
                                    </VStack>
                                </VStack>


                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mt={"20px"} mr={"0.5rem"}>
                                        <input tabIndex={0}{...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle?"* "+errors.calle.message:""}</Span>
                                    </VStack>
                                    <VStack mt={"20px"} mr={"0.5rem"}>
                                        <input tabIndex={0}{...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Nro' maxLength={5} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle?"* "+errors.numeroCalle.message:""}</Span>
                                    </VStack>
                                    <VStack mt={"20px"}>
                                        <input tabIndex={0}{...register("piso", { required: false, maxLength: 8, })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                                    </VStack>

                                </VStack>
                            </VStack>

                    <VStack mt={"20px"}>
                        <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>Sucursal donde querés finalizar el tramite</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad de la  sucursal"}
                                    {...register("provinciaSuc", { required: REQUIRED_FIELD })}
                                    onChange={(e) => BuscPartidosSuc(e.target.value)} name="provinciaSuc">
                                    <option value="" >Ubicación</option>
                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                </select>

                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.provinciaSuc ? "* " + errors.provinciaSuc.message : ""}
                                </Span>
                            </VStack>
                            <VStack>
                                <select tabIndex={0} aria-label={"Seleccione el partido de la  sucursal"} {...register("partidoSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscLocSuc(e.target.value)} name="partidoSuc"
                                    >
                                    <option value="" >Partido</option>
                                    {partidosSuc &&
                                        partidosSuc.map((item: Partido) =>
                                            <option value={item.id_partido} key={item.desc_partido}>{item.desc_partido}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.partidoSuc ? "* " + errors.partidoSuc.message : ""}
                                </Span>
                            </VStack>
                        </VStack>
                        <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la localidad de la  sucursal"} {...register("localidadSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscSuc(e.target.value)} name="localidadSuc"
                                    >
                                    <option value="" >Localidad/barrio</option>
                                    {localidadesSuc &&
                                        localidadesSuc.map((item: Localidad) =>
                                            <option value={item.id_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                        )}
                                </select>

                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.localidadSuc ? "* " + errors.localidadSuc.message : ""}
                                </Span>
                            </VStack>
                            <VStack>
                                <select tabIndex={0} aria-label={"Seleccione la  sucursal"} style={{ width: "100%" }} {...register("sucursal", { required: REQUIRED_FIELD })} name="sucursal" >
                                    <option value="" disabled>Sucursal</option>
                                    {sucursales &&
                                        sucursales.map((item: Sucursal) =>
                                            <option value={item.cod_ubic} key={item.suc_nombre}>{item.cod_ubic + " - " + item.suc_nombre}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.sucursal ? "* " + errors.sucursal.message : ""}
                                </Span>
                            </VStack>
                        </VStack>
                    </VStack>
                    
                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{height:"calc(1.8em + 0.75rem + 2px)"}} py={'10px !important'}>Enviar</Button>


                </form>
            </VStack>

        </Box>

    )
    
};



export default ComponenteTarjetaPactar;
